import type { ReactNode, SyntheticEvent } from "react";
import type { PopperPlacementType } from "@mui/material";
import { ClickAwayListener, Paper, Popper } from "@mui/material";

interface Properties {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  placement?: PopperPlacementType;
  elevation?: number;
  borderRadius?: number;
  children: ReactNode;
  zIndex?: number;
}

export default function PopMenu(props: Properties): ReactNode {
  function handleClose(event: Event | SyntheticEvent): void {
    if (
      props.anchorEl === null ||
      props.anchorEl.contains(event.target as HTMLElement)
    ) {
      return;
    }
    props.onClose();
  }

  const borderRadius =
    props.borderRadius === undefined ? "0" : `${props.borderRadius}px`;

  return (
    <Popper
      open={props.open}
      anchorEl={props.anchorEl}
      role={undefined}
      placement={props.placement ?? "bottom-start"}
      sx={{ zIndex: props.zIndex ?? 1400 }}
    >
      <ClickAwayListener onClickAway={handleClose}>
        <Paper
          elevation={props.elevation ?? 4}
          square={borderRadius === "0"}
          sx={{ padding: "0", borderRadius: borderRadius }}
        >
          {props.children}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}
